import { normalizeText } from "../NormalizeText";

export const caseInsensitiveText = (text: string): string => text.toLowerCase();
export const normalizedDescription = (text: string): string => normalizeText(text).toLowerCase();
